<template>
   <section class="empty-split-hero">
      <div class="content">
         <p class="label grey underline">
            Loading
         </p>
         <div class="boxes"></div>
      </div>
      <div class="empty-image"></div>
   </section>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@import "~/assets/scss/globals/empty-split-hero";
</style>
